import { render, staticRenderFns } from "./TeamRequests.vue?vue&type=template&id=7d322878&scoped=true"
import script from "./teamRequests.ts?vue&type=script&lang=ts&external"
export * from "./teamRequests.ts?vue&type=script&lang=ts&external"
import style0 from "./TeamRequests.vue?vue&type=style&index=0&id=7d322878&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d322878",
  null
  
)

export default component.exports